export default __webpack_public_path__ + "a18aa2925a1b1a99bbf18360f7459fbc.png";